import { z } from 'zod'

export const EditConnectionModalSchema = z
	.object({
		appointmentToEdit: z.string().min(1, 'Selecione uma consulta'),
		newNext: z.string().nullish(),
	})
	.superRefine((data, ctx) => {
		if (data.appointmentToEdit && !data.newNext) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: 'Selecione uma próxima consulta.',
				path: ['newNext'],
			})
		}
	})
